<template>
  <UiSlider
    v-guides-view-tracker="getGuidesViewEventParams"
    :slides="currentList"
    pagination
    class="guides"
    mousewheel
    :slides-per-view="1"
    :space-between="16"
  >
    <template #slide="{ index }">
      <GuideListItem
        :guide="currentList[index]"
        :has-tours="hasTours"
        :default-sogu-fields="defaultSoguFields"
      />
    </template>
  </UiSlider>
</template>

<script setup lang="ts">
  import { UiSlider } from '@experience/core-slider-ui';
  import type { Guide } from '@/shared/api/experience';

  import { GuideListItem } from '@/entities/guide';
  import type { ContextGeoSubject } from '@/shared/types/geography.ts';
  import { useViewTracker } from '@/entities/sogu';
  interface Props {
    currentList: Guide[];
    hasTours?: boolean;
    defaultSoguFields: ContextGeoSubject;
  }
  const props = defineProps<Props>();

  const getGuidesViewEventParams = () => props.defaultSoguFields.soguStamp;
  const vGuidesViewTracker = useViewTracker('listing:guides.view');
</script>
<style scoped lang="scss">
  .guides {
    :deep(.swiper-pagination) {
      --swiper-pagination-bottom: 0;
    }
  }
</style>
